import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-500/15 text-secondary-400 border border-secondary-500/20 mb-3">
            <i className="ri-vidicon-line mr-1"></i>精彩视频
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            影视解说与盘点
          </h2>
          <p className="mt-2 text-sm text-foreground-500">精选影视内容深度解读，发现更多好片</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {mediaItems.map((item) => (
            <a
              key={item.title}
              href="#media"
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/50 hover:border-primary-500/30 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 to-transparent"></div>
                <span className="absolute bottom-2 right-2 bg-background-50/80 backdrop-blur-sm text-xs font-medium text-foreground-700 px-2 py-0.5 rounded-md">
                  {item.duration}
                </span>
                <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-xl text-background-50 ml-0.5"></i>
                  </span>
                </span>
              </div>
              <div className="p-3">
                <h3 className="text-xs font-medium text-foreground-700 group-hover:text-primary-400 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">
                  <i className="ri-eye-line mr-1"></i>
                  {item.views} 次观看
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}